<template>
	<button class="view-ui-button-kit" v-on:click="Handle_OnClick">
		<h6>{{ featureName }}</h6>

		<figure>
			<img class="filter-invert" v-bind:src="iconUrl" />
		</figure>
	</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { assetRef } from '@/Manager/Asset';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonKit extends ViewBase {
		/**
		 * @type string
		 */
		public get iconUrl(): string {
			return assetRef('image/icon/kit/' + this.iconFilename);
		}

		/**
		 * @type string
		 */
		@Prop({ default: 'rulebooks.svg' })
		public iconFilename!: string;

		/**
		 * @type string
		 */
		@Prop({ default: 'Rulebooks' })
		public featureName!: string;

		/**
		 * @type string
		 */
		@Prop()
		public route!: string;

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClick(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$router.push({
				name: this.route,
			});
		}
	}
</script>

<style lang="scss">
	.view-ui-button-kit {
		align-items: center;
		aspect-ratio: 1 / 1;
		background-color: var(--chalky-blue-4);
		border-radius: var(--border-radius);
		color: var(--chalky-white);
		display: flex;
		flex-direction: column-reverse;
		padding: 0.25rem;

		figure {
			align-items: center;
			display: flex;
			flex-grow: 1;
			justify-content: center;

			img {
				max-height: 66%;
				max-width: 75%;
				transform: translateY(0.5rem);
			}
		}

		h6 {
			flex-shrink: 1;
			padding: 0.75rem 0;
		}
	}

	// State
	// ---------------------------------------------------------------------------

	.view-ui-button-kit.disabled {
		opacity: 0.33;
		pointer-events: none;
	}
</style>
